import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const InputPass = ({ name, placeholder, handleInputChange }) => {
    const [isShowing, setIsShowing] = useState(false);

    return (
        <>
            <input
                autoComplete="off"
                name={name}
                type={(isShowing) ? `text` : `password`}
                placeholder={placeholder}
                onChange={handleInputChange}
                className="col-10"
            ></input>
            <button type='button' className='btn-show'
                onClick={() => { setIsShowing(!isShowing) }}>
                <i className={(isShowing) ? `fas fa-eye` : `fas fa-eye-slash`}></i>
            </button>
        </>
    )
}


InputPass.propTypes = {
    name: PropTypes.string.isRequired,
    handleInputChange: PropTypes.func.isRequired
}